"use client";

import { useEffect, useRef } from "react";
import { usePathname, useRouter } from "next/navigation";
import { authClient } from "@hello/auth/client";

interface GoogleOneTapProps {
  isLoggedIn: boolean;
}

export function GoogleOneTap({ isLoggedIn }: GoogleOneTapProps) {
  const router = useRouter();
  const pathname = usePathname();
  // Tracks the last path we prompted on, so navigating between pages can
  // re-offer One Tap after Google auto-dismisses the prompt.
  const promptedFor = useRef<string | null>(null);

  useEffect(() => {
    // Skip One Tap on the auth pages — they already show a full Google button.
    if (isLoggedIn || pathname?.startsWith("/auth")) {
      return;
    }
    if (promptedFor.current === pathname) return;
    promptedFor.current = pathname;

    void authClient.oneTap({
      fetchOptions: {
        onSuccess: () => {
          router.refresh();
        },
      },
    });
  }, [isLoggedIn, pathname, router]);

  return null;
}
